import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Circle,
  CircleCheck,
  PencilLine,
  RefreshCcw,
  WalletMinimal,
} from "lucide-react";
import { SolidButton } from "../../../global/SolidButton";
import { BorderButton } from "../../../global/BorderButton";
import { MyModal } from "../../../global/MyModal";
import { Gear } from "phosphor-react";
import {
  AddCard,
  RadioButtonUnchecked,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import {
  getPayoutOptions,
  updatePayoutOptions,
  updateWithdrawalStatus,
} from "../api";
import MyLoader from "../../../util/MyLoader";
import toast from "react-hot-toast";

export default function WithdrawSetting() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [salt, setSalt] = useState("");
  const [loading, setLoading] = useState(true);
  const [enableWithdrawal, setEnableWithdrawal] = useState(false);

  // API data
  const [payoutOptions, setPayoutOptions] = useState({
    payout_options: [],
    total_threshold: 0,
    app_name: "",
    app_id: "",
  });

  // Editable modal data
  const [pData, setPData] = useState([]);

  /* ---------------- Fetch API ---------------- */

  const fetchPayoutOpts = async () => {
    try {
      const res = await getPayoutOptions();
      const app = res?.data?.app || {};

      const options = app?.payout_options;

      const payoutOptions =
        typeof options === "string" ? JSON.parse(options) : options || {};

      const payoutArray = Object.entries(payoutOptions).map(
        ([name, value]) => ({
          name,
          ...value,
        }),
      );

      setPayoutOptions({
        payout_options: payoutArray,
        total_threshold: app.threshold || 0,
        app_name: app?.name,
        app_id: app?.app_id,
      });

      setSalt(app?.salt || "");
      setEnableWithdrawal(app?.status);

      const mapped = payoutArray.map((item, index) => ({
        id: index + 1,
        code: item.name,
        isSelected: item.is_active,
        thresholds: Number(item.threshold || 0),
      }));

      setPData(mapped);
    } catch (err) {
      console.error("Failed to fetch payout options", err);
    } finally {
      setLoading(false);
    }
  };
  const didFetch = useRef(false);

  useEffect(() => {
    if (didFetch.current) return;
    didFetch.current = true;
    fetchPayoutOpts();
  }, []);

  const updateStatus = async (value) => {
    try {
      const res = await updateWithdrawalStatus({ status: value });
      // if(res.status==200){
      //const st=res.data?.status;

      console.log("status:", res?.data?.status);
      setEnableWithdrawal(value);
      toast(value ? "enable Withdrawal" : "disable Withdrawal");

      //  }
    } catch (err) {
      console.error("Failed to update status", err);
    }
  };
  /* ---------------- Helpers ---------------- */

  function generateSalt(length = 16) {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join(
      "",
    );
  }

  const toggleGateway = (id) => {
    setPData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isSelected: !item.isSelected } : item,
      ),
    );
  };

  const selectedGateways = pData.filter((item) => item.isSelected);
  const selectedCount = selectedGateways.length;

  const totalThreshold = selectedGateways.reduce(
    (sum, item) => sum + Number(item.thresholds || 0),
    0,
  );

  const handleSubmit = async () => {
    try {
      const payout_options = {};

      pData.forEach((item) => {
        payout_options[item.code] = {
          is_active: item.isSelected,
          threshold: item.thresholds || 0,
        };
      });
      const payload = {
        status: enableWithdrawal,
        salt: salt,
        payout_options: payout_options,
      };
      const res = await updatePayoutOptions(payload);
      if (res.status === 200) {
        const app = res?.data?.app || {};

        const options = app?.payout_options || [];
        const payoutOptions = JSON.parse(options);
        const payoutArray = Object.entries(payoutOptions).map(
          ([name, value]) => ({
            name,
            ...value,
          }),
        );

        setPayoutOptions({
          payout_options: payoutArray,
          total_threshold: app.threshold || 0,
          app_name: app?.name,
          app_id: app?.app_id,
        });

        setSalt(app?.salt || "");
        setEnableWithdrawal(app?.status);

        // Sync modal data with API
        const mapped = payoutArray.map((item, index) => ({
          id: index + 1,
          code: item.name,
          isSelected: item.is_active,
          thresholds: Number(item.thresholds || 0),
        }));

        setPData(mapped);

        setIsModalOpen(false);
      }
    } catch (err) {
      console.error("failed to update app :", err);
    }
  };

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className=" bg-slate-100 dark:text-slate-100  dark:bg-slate-600/60 mx-40 border rounded-lg shadow-sm flex flex-col">
        {/* Header */}
        <div className="w-full flex items-center justify-between  bg-gray-400/20 px-6 py-4 rounded-t-lg">
          <div className="flex flex-col">
            <span className="text-lg font-bold">{payoutOptions.app_name}</span>
            <span className="text-sm ">App Id: {payoutOptions.app_id}</span>
          </div>
          {/* Toggle */}
          <div className="ml-auto flex items-start">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={enableWithdrawal}
                //  value={enableWithdrawal}
                onChange={(e) => {
                  const newStatus = e.target.checked;
                  console.log("status:", newStatus);
                  updateStatus(newStatus);
                }}
              />
              <div
                className="w-10 h-5 bg-gray-300 dark:bg-gray-400 
              rounded-full peer peer-checked:bg-blue-600 
              transition-all
              after:content-[''] after:absolute after:w-4 after:h-4 
              after:bg-white after:rounded-full 
              after:top-[2px] after:left-[2px]
              peer-checked:after:translate-x-5 
              after:transition-all"
              ></div>
            </label>
          </div>
        </div>

        {/* Content */}
        <div className="px-6 py-4 flex flex-col space-y-4">
          <span className="text-sm font-semibold">
            Payout Options & Thresholds
          </span>

          <div className="grid grid-cols-1  lg:grid-cols-3 gap-4">
            {payoutOptions?.payout_options?.map((item, index) => (
              <div
                key={index}
                className={`text-xs px-3 py-3 rounded-md flex justify-between border
                ${
                  item.is_active
                    ? "bg-green-500/10 border-green-600 text-green-700"
                    : "bg-gray-200 dark:bg-slate-600/60 dark:text-slate-300  border-gray-300 text-slate-700"
                }`}
              >
                <span className="overflow-auto">{item.name}</span>
                <span>₹{item.threshold}/day</span>
              </div>
            ))}
          </div>

          {/* Salt */}
          <span className="text-sm font-semibold">Payout Salt</span>
          <span className="text-sm border rounded-lg px-3 py-2 font-mono  bg-gray-200 dark:bg-slate-600/60">
            {salt || "Not set"}
          </span>

          {/* Total Threshold */}
          <span className="text-sm font-semibold">Total Daily Threshold</span>
          <div className="border border-blue-600 rounded-lg bg-blue-600/10 p-3">
            <h4 className="font-bold text-blue-600">
              ₹{payoutOptions.total_threshold}/Day
            </h4>
            <span className="text-xs text-blue-500">
              Sum of all active payout option thresholds
            </span>
          </div>

          {/* Buttons */}
          <div className="flex justify-between mt-4">
            <SolidButton onClick={() => setIsModalOpen(true)}>
              <PencilLine className="w-4 h-4" />
              <span>Edit</span>
            </SolidButton>

            <BorderButton>
              <WalletMinimal className="w-4 h-4" />
              <span>App Transaction</span>
            </BorderButton>
          </div>
        </div>
      </div>

      {/* ================= MODAL ================= */}

      <MyModal
        isOpen={isModalOpen}
        title="Edit Withdrawal"
        onClose={() => setIsModalOpen(false)}
        width="620px"
        
        icon={Gear}
      >
        <div className="flex flex-col space-y-4 mt-4 dark:text-slate-50 ">
          {/* Salt Input */}
          <label className="text-sm font-medium">Salt</label>
          <div className="relative">
            <input
              type="text"
              value={salt}
              onChange={(e) => setSalt(e.target.value)}
              className="w-full text-sm py-2 px-3 border rounded-lg dark:text-slate-50"
              placeholder="Enter Salt Key"
            />
            <RefreshCcw
              className="absolute right-3 top-3 w-4 h-4 cursor-pointer"
              onClick={() => setSalt(generateSalt())}
            />
          </div>

          {/* Total Threshold */}
          <div className="border border-blue-700 rounded-lg p-3 bg-blue-100 dark:bg-blue-500/10">
            <h4 className="text-blue-700 font-bold">₹{totalThreshold}/Day</h4>
            <span className="text-xs text-blue-600">
              Auto-calculated from selected gateways
            </span>
          </div>

          {/* Gateways */}
          <div className="flex items-center mt-2">
            <AddCard className="mr-2" />
            <span className="text-sm font-semibold">Payout Gateways</span>
            <span className="ml-auto text-xs bg-blue-200 dark:bg-blue-500/20 px-2 py-1 rounded-full">
              {selectedCount} selected
            </span>
          </div>
          {/* jjkdksjdksdksjdkdsds */}

          <div className="grid grid-cols-3 gap-3">
            {pData.map((data, index) => (
              <div
                key={index}
                onClick={() => toggleGateway(data.id)}
                className={`border rounded-lg p-3 cursor-pointer
                ${
                  data.isSelected
                    ? "border-green-500 bg-[var(--foreground)] dark:text-slate-200 text-slate-700"
                    : "border-gray-400"
                }`}
              >
                <div className="flex items-center justify-start space-x-2">
                  {data.isSelected ? (
                    <CircleCheck className="w-5 h-5 text-green-600" />
                  ) : (
                    <Circle className=" w-5 h-5 text-white" />
                  )}

                  <span className="text-xs font-bold ">{data.code}</span>
                </div>
                <span className="text-[10px] dark:text-slate-400 text-slate-700">
                  Daily Threshold
                </span>

                <input
                  type="number"
                  min={1}
                  value={data.isSelected ? data.thresholds : ""}
                  disabled={!data.isSelected}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setPData((prev) =>
                      prev.map((item) =>
                        item.id === data.id
                          ? { ...item, thresholds: value }
                          : item,
                      ),
                    );
                  }}
                  className="w-full mt-2 text-xs py-1 px-2 border rounded"
                  placeholder="Daily Threshold"
                />
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="flex justify-end space-x-2 mt-4">
            <BorderButton onClick={() => setIsModalOpen(false)}>
              Cancel
            </BorderButton>
            <SolidButton onClick={() => handleSubmit()}>Update App</SolidButton>
          </div>
        </div>
      </MyModal>
    </Fragment>
  );
}
